import { render } from "./Page.vue?vue&type=template&id=bdc9d344&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=bdc9d344&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bdc9d344"

export default script